import React, { useCallback } from 'react'
import { useSnackbarMessages } from '../../../Components/AppSnackbar/Hooks/useSnackbarMessages'
import { DeleteIconButton } from '../../../Components/Buttons/DeleteIconButton'
import { AppPermission } from '../../../Hooks/useAppPermissions'
import { LabContactSchema } from '../../../Schema/LabContactSchema'
import { useDeleteLabContact } from '../Hooks/useDeleteLabContact'

interface DeleteLabContactButtonProps {
  schema: LabContactSchema
  onDeleted?: () => void
}

export const DeleteLabContactButton: React.FC<DeleteLabContactButtonProps> = ({
  schema,
  onDeleted = () => {},
}) => {
  const { addSuccessMessage, addErrorMessage } = useSnackbarMessages()
  const { deleteLabContact, processing, errorMessage } = useDeleteLabContact()

  const handleOnDelete = useCallback(() => {
    deleteLabContact(schema.id).then(() => {
      addSuccessMessage('The carrier deleted successfully.')
      onDeleted()
    }).catch(() => {
      addErrorMessage(errorMessage)
    })
  }, [schema?.id, addSuccessMessage, addErrorMessage, deleteLabContact, errorMessage, onDeleted])

  return (
    <DeleteIconButton permissions={[AppPermission.LabContactDelete]} onDelete={handleOnDelete} disabled={processing} />
  )
}
